

  let sliceIndex = "pxstore.com".lastIndexOf("."),
  getUrlExt = "pxstore.com".slice(sliceIndex);
  export const sellerURl = window.location.protocol+"//dashboard.pxstores"+`${getUrlExt}`;